import EditOrganisationPage from "../views/Organisations/EditOrganisation.jsx"
import ViewOrganisationPage from "../views/Organisations/ViewOrganisation.jsx"

import {UserIsAdmin} from "../utils/AuthRouter"



const organisationRoutes = [

{
    path: '/edit',
        component: UserIsAdmin(EditOrganisationPage)
},
{
    path:'/view',
        component:UserIsAdmin(ViewOrganisationPage)
}
]

export default organisationRoutes


// WEBPACK FOOTER //
// ./src/routes/organisation.jsx